import type { IToolbarItemConfigTiptap } from 'ricos-types';

/** Filters first and last separators if there is nothing behind/ahead of them and
 * if there are two or more next to each other, it only leaves one
 * @example
 * | A | B || C | D | -> A | B | C | D
 */
export const filterExcessiveToolbarSeparators = (itemsConfig: IToolbarItemConfigTiptap[]) => {
  return itemsConfig.filter((config, index, allConfigs) => {
    return config.id !== 'separator' || (index !== 0 && allConfigs[index - 1]?.id !== 'separator');
  });
};
